import React, { useState, useRef } from "react"

const Iframe = ({ src, title = "iframe", height = "600px" }) => {
    const [iframeHeight, setHeight] = useState("0px")
    const iframeRef = useRef(null)
    
    const handleIframeLoad = () => {
        setHeight(height)
    }
    
    return (
        <iframe
            ref={iframeRef}
            title={title}
            src={src}
            style={{ 
                height: iframeHeight, 
                overflow: "visible",
                border: "none",
                width: "100%" 
            }}
            onLoad={handleIframeLoad}
        />
    )
}

export default Iframe
